'use strict';

/**
 * A builder for SemanticMetricClientNonAuth
 * NOTE: This code was generated and should not be changed
 *
 * @param {Object} data   The event data
 * @return {Object}   The validated and properly formatted data
 */
function createSemanticMetricClientNonAuth(data) {
  var validated = data;
  if (process.env.DEBUG === 'true') {
    var validateSchema = require('spotify-debug-tools/debug_schema');
    validated = validateSchema(data, {
      key: {
        type: 'string',
        nullable: true,
      },
      metric_type: {
        type: 'string',
        nullable: true,
      },
      component_id: {
        type: 'string',
        nullable: true,
      },
      what: {
        type: 'string',
        nullable: true,
      },
      value: {
        type: 'number',
        nullable: true,
      },
      tags: {
        type: 'string',
        complex_type: 'Object',
        nullable: true,
      }
    });
  }

  return {
    name: 'SemanticMetricClientNonAuth',
    data: validated
  };
}

module.exports = createSemanticMetricClientNonAuth;
